import { Component, OnInit } from "@angular/core";
import { KeycloakService } from "keycloak-angular";
import { Roles } from "../../models/roles";
import { AccountService } from "../../services/account.service";
import { AuthGuardService } from "../../services/auth-guard.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"]
})
export class HeaderComponent implements OnInit {
  supportedLanguages: string[] = [];
  dropDownLanguages: string[] = [];

  constructor(
    public keycloak: KeycloakService,
    public accountService: AccountService,
    public authService: AuthGuardService,
    public trans: TranslateService
  ) {}

  ngOnInit() {
    this.switchLang("FR");
    this.accountService.getSupportedLocales().then(l => {
      this.supportedLanguages = l;
      this.dropDownLanguages = l.filter(i => i !== this.accountService.locale);
    });
  }

  logout() {
    this.keycloak.logout();
  }

  /**
   * Reload language file and send a request to the server to update current user's locale
   */
  switchLang(selectedLanguage: string) {
    this.accountService.locale = selectedLanguage;
    this.accountService
      .updateLocale(selectedLanguage)
      .subscribe(res => console.log(res));
    this.dropDownLanguages = this.supportedLanguages.filter(
      i => i !== selectedLanguage
    );
    this.trans.use(selectedLanguage.toLowerCase());
  }
}



// WEBPACK FOOTER //
// ./src/app/include/header/header.component.ts